import axios from "@/axios.js";
import AuditTrials from "./audit_trials_service";

export default {
  getAllAuditTrials({ commit }, item) {
    return new Promise((resolve, reject) => {
      AuditTrials.getAllAuditTrials(item, (rows, lastRow) => {
        // // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  fetchAuditTrials(context, audit_trialId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/audit_trials/audit_trials/${audit_trialId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeAuditTrial(context, audit_trialId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/audit_trials/audit_trials/${audit_trialId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExistingAuditTrialLists(context, audit_trial_from) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/audit_trials/audit_trials/get_existing_audit_trial_lists/${audit_trial_from}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  searchExistingAuditTrialLists(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/audit_trials/audit_trials/search_existing_audit_trial_lists", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateAuditTrials({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/audit_trials/audit_trials/update_audit_trial", {
          item: item
        })
        .then(response => {
        
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addAuditTrials({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/audit_trials/audit_trials/add_new_audit_trial", {
          item: item
        })
        .then(response => {
          // // console.log(response)
          commit(
            "ADD_ITEM",
            Object.assign(item, {
              id: response.data.id
            })
          );
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addScheduleToCalendar({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/audit_trials/audit_trials/add_schedule_to_calendar", {
          item: item
        })
        .then(response => {
          // // console.log(response)
          commit(
            "ADD_ITEM",
            Object.assign(item, {
              id: response.data.id
            })
          );
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeAuditTrials({ commit }, audit_trialId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .delete(`/api/audit_trials/audit_trials/${audit_trialId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllActionTypesForAuditTrials(context) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/audit_trials/audit_trials/get_all_action_types`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllAuditTrialsByActionype({ commit }, action_type_id) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .get(`/api/audit_trials/audit_trials/get_all_audit_trials_by_action_type/${action_type_id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAuditTrials({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/audit_trials/audit_trials/get_audit_trials", {
          item: item
        })
        .then(response => {
          
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllDialActions({ commit }, item) {
    return new Promise((resolve, reject) => {
      AuditTrials.getAllDialActions(item, (rows, lastRow) => {
        // // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  selectDialActions({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/audit_trials/audit_trials/select_dial_action", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDialAction(context) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/audit_trials/audit_trials/get_dial_action`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllActionTypeOptions({ commit }, item) {
    return new Promise((resolve, reject) => {
      AuditTrials.getAllActionTypeOptions(item, (rows, lastRow) => {
        // // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  selectActionTypeOutcomeOption({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/audit_trials/audit_trials/select_action_type_outcome_option", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateActionTypeOutcomeOption({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/audit_trials/audit_trials/update_action_type_outcome_option", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeActionTypeOutcomeOption({ commit }, optionId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/audit_trials/audit_trials/remove_action_type_outcome_option/${optionId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchOptionsById(context, optionId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/audit_trials/audit_trials/${optionId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchOptionsByActionTypeAndOutcome({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/audit_trials/audit_trials/fetch_options_by_action_type_and_outcome", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
